import React, { Component } from 'react';
import Sendgoods from './senddoods';

/**
 * 发货弹窗
 */
export class SendGoods extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        const { row, entity } = this.props;
        return (
            <div>
                <Sendgoods rows={row} entity={entity} />
            </div>
        );
    }
}
